import { useState } from 'react'
import { api } from 'lib/axios'

const DocumentsClassificationProcess = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/document-classification-process',
    payload
  )
  return response
}

export const useDocumentsClassificationProcess = () => {
  const [
    isDocumentsClassificationProcessDataLoading,
    setIsDocumentsClassificationProcessDataLoading
  ] = useState(false)

  const handleDocumentsClassificationProcess = async payload => {
    setIsDocumentsClassificationProcessDataLoading(true)
    try {
      const response = await DocumentsClassificationProcess(payload)
      if (response) {
        return response
      } else {
        console.error('Documents Classification Process failed:', response)
        return null
      }
    } catch (error) {
      console.error('Documents Classification Process failed:', error)
    } finally {
      setIsDocumentsClassificationProcessDataLoading(false)
    }
  }

  return {
    isDocumentsClassificationProcessDataLoading,
    handleDocumentsClassificationProcess
  }
}
